import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';
import D from './RespostasRapidas.design';

// Mockup de celular: a resposta rápida é uma mensagem, então o editor mostra
// exatamente o que o cliente recebe. Cores de produto WhatsApp ficam aqui dentro.

const TRAMA_CHAT =
  "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23a7a7a7' fill-opacity='0.08'%3E%3Ccircle cx='30' cy='30' r='1.5'/%3E%3C/g%3E%3C/svg%3E\")";

function formatarDuracao(segundos) {
  const total = Math.max(0, Math.round(segundos || 0));
  const min = Math.floor(total / 60);
  const seg = total % 60;
  return `${min}:${seg.toString().padStart(2, '0')}`;
}

export default function PreviewRespostaRapida({ tipo, titulo, texto, nomeArquivo, duracaoAudio, temAudio }) {
  const agora = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const temConteudo =
    (tipo === 'texto' && texto) || (tipo === 'arquivo' && nomeArquivo) || (tipo === 'audio' && temAudio);

  return (
    <div>
      <div className={D.previewPhoneFrame}>
        <div className={D.previewPhoneInner}>
          <div className={D.previewNotch}>
            <div className={D.previewNotchPill} />
          </div>

          <div className={D.previewWhatsappHeader}>
            <Iconify icon="eva:arrow-back-outline" width={16} className="text-white/70" />
            <div className="w-7 h-7 bg-white/20 rounded-full flex items-center justify-center">
              <Iconify icon="eva:person-outline" width={14} className="text-white/60" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-xs font-medium truncate">Cliente</p>
              <p className="text-[10px] text-green-200">online</p>
            </div>
            <Iconify icon="eva:video-outline" width={16} className="text-white/60" />
            <Iconify icon="eva:phone-outline" width={16} className="text-white/60" />
          </div>

          <div
            className={D.previewChatArea}
            style={{ background: '#efeae2', backgroundImage: TRAMA_CHAT, backgroundSize: '30px 30px' }}
          >
            <div className="flex justify-end">
              <div className={D.previewMessageBubble}>
                <div className={D.previewMessageTail} />

                {tipo === 'arquivo' && nomeArquivo && (
                  <div className={D.previewDocCard}>
                    <Iconify icon="eva:file-text-outline" width={20} className="text-[#008069] flex-shrink-0" />
                    <p className="text-[11.5px] font-medium text-[#111b21] truncate">{nomeArquivo}</p>
                  </div>
                )}

                {tipo === 'audio' && temAudio && (
                  <div className={D.previewVoiceRow}>
                    <Iconify icon="eva:play-circle-fill" width={26} className="text-[#008069] flex-shrink-0" />
                    <div className={D.previewVoiceTrack}>
                      <span className={D.previewVoiceKnob} />
                    </div>
                    {duracaoAudio > 0 && (
                      <span className="text-[10px] text-[#667781] tabular-nums">{formatarDuracao(duracaoAudio)}</span>
                    )}
                  </div>
                )}

                {tipo === 'texto' && (
                  <p className={texto ? D.previewText : D.previewPlaceholder}>
                    {texto || 'A mensagem aparece aqui conforme você escreve.'}
                  </p>
                )}

                {tipo !== 'texto' && !temConteudo && (
                  <p className={D.previewPlaceholder}>
                    {tipo === 'arquivo' ? 'Anexe um arquivo para ver o preview.' : 'Grave um áudio para ver o preview.'}
                  </p>
                )}

                <div className={D.previewTimestamp}>
                  <span>{agora}</span>
                  <Iconify icon="eva:done-all-outline" width={13} className="text-[#53bdeb]" />
                </div>
              </div>
            </div>
          </div>

          <div className={D.previewInputBar}>
            <Iconify icon="eva:smiling-face-outline" width={18} className="text-[#8696a0]" />
            <div className="flex-1 bg-white rounded-full px-3 py-1.5 text-[11px] text-[#8696a0]">Mensagem</div>
            <Iconify icon="eva:mic-outline" width={18} className="text-[#8696a0]" />
          </div>

          <div className={D.previewHomeIndicator}>
            <div className="w-28 h-1 bg-[#3f3f46] rounded-full" />
          </div>
        </div>
      </div>

      <p className={D.previewCaption}>
        {titulo ? `Aparece na lista do chat como “${titulo}”.` : 'Dê um nome para encontrá-la na lista do chat.'}
      </p>
    </div>
  );
}

PreviewRespostaRapida.propTypes = {
  tipo: PropTypes.string,
  titulo: PropTypes.string,
  texto: PropTypes.string,
  nomeArquivo: PropTypes.string,
  duracaoAudio: PropTypes.number,
  temAudio: PropTypes.bool,
};
